const PARTIAL_NUMBER = /^-?\d*(\.\d*)?$/;
const COMPLETE_NUMBER = /^-?(\d+(\.\d+)?|\.\d+)$/;

export function sanitizeNumericInput(input: string): string | null {
  const text = input.replace(',', '.');
  return PARTIAL_NUMBER.test(text) ? text : null;
}

export function toCanonicalNumber(text: string): string | null {
  return COMPLETE_NUMBER.test(text) ? String(Number(text)) : null;
}
